import { Component, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogComponent } from '../dialog-component';
import { Transfer } from '../page-component';
import { Shell } from '../shell';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss']
})
export class MessageDialogComponent extends DialogComponent {
  private domSanitizer = inject(DomSanitizer);

  @Transfer()
  title : string = '';

  @Transfer()
  message : any = '';

  init(title : string, message : string | any) {
    this.title = title;

    if (typeof message == 'object' && message.type == 'html') {
      this.message = this.domSanitizer.bypassSecurityTrustHtml(message.content);
    } else {
      this.message = message;
    }
  }

}

Shell.__messageDialogComponent = MessageDialogComponent;
